import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "AddQuestionView" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { onMounted, ref } from "vue";
import MdEditor from "@/components/MdEditor.vue";
import message from "@arco-design/web-vue/es/message";
import { QuestionAddRequest, QuestionControllerService } from "../../generated";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddQuestionView',
  setup(__props) {

const question = ref({
  answer: "# 参考答案\n",
  content: "# 题目描述\n",
  judgeCase: [
    {
      input: "",
      output: "",
    },
  ],
  judgeConfig: {
    memoryLimit: 1000,
    stackLimit: 1000,
    timeLimit: 1000,
  },
  tag: ["简单"],
  title: "A + B",
} as QuestionAddRequest);

const route = useRoute();
const isUpdatePage = ref(route.path.includes("update"));

const loadData = async () => {
  const id = route.query.id;
  if (!id) {
    return;
  }
  const res: any = await QuestionControllerService.getQuestionByIdUsingGet(
    id as any
  );
  if (res.code === 0) {
    question.value = res.data as any;
    if (!question.value.tag) {
      question.value.tag = ["简单"];
    } else {
      question.value.tag = JSON.parse(res.data.tag);
    }
    if (!question.value.judgeConfig) {
      question.value.judgeConfig = {
        memoryLimit: 1000,
        stackLimit: 1000,
        timeLimit: 1000,
      };
    } else {
      question.value.judgeConfig = JSON.parse(res.data.judgeConfig);
    }
    if (!question.value.judgeCase) {
      question.value.judgeCase = [
        {
          input: "",
          output: "",
        },
      ];
    } else {
      question.value.judgeCase = JSON.parse(res.data.judgeCase);
    }
  } else {
    message.error("加载失败！ " + res.message);
  }
};
onMounted(() => {
  loadData();
});

const onContentChange = (v: string) => {
  question.value.content = v;
};
const onAnswerChange = (v: string) => {
  question.value.answer = v;
};

const handleAdd = () => {
  if (question.value.judgeCase?.length === 10) {
    message.error("测试用例不能多于十个！");
    return;
  }
  question.value.judgeCase?.push({
    input: "",
    output: "",
  });
};
const handleDelete = (index: number) => {
  if (question.value.judgeCase?.length === 1) {
    message.error("测试用例不能少于一个！");
    return;
  }
  question.value.judgeCase?.splice(index, 1);
};
const handleSubmit = async () => {
  // 区分更新还是创建
  if (isUpdatePage.value) {
    const res = await QuestionControllerService.updateQuestionUsingPost(
      question.value
    );
    if (res.code === 0) {
      message.success("更新题目成功！");
    } else {
      message.error("更新题目失败 " + res.message);
    }
  } else {
    const res = await QuestionControllerService.addQuestionUsingPost(
      question.value
    );
    if (res.code === 0) {
      message.success("创建题目成功！");
    } else {
      message.error("创建题目失败 " + res.message);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isUpdatePage.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "发布题目"))
      : (_openBlock(), _createElementBlock("h1", _hoisted_3, "更新题目")),
    _createVNode(_component_a_form, {
      model: question.value,
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: question.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((question.value.title) = $event)),
              class: "formItem",
              placeholder: "请输入标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "题目描述"
        }, {
          default: _withCtx(() => [
            _createVNode(MdEditor, {
              "handle-change": onContentChange,
              value: question.value.content,
              class: "formItem"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "answer",
          label: "参考答案"
        }, {
          default: _withCtx(() => [
            _createVNode(MdEditor, {
              "handle-change": onAnswerChange,
              value: question.value.answer,
              class: "formItem"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tag",
          label: "标签"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: question.value.tag,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((question.value.tag) = $event)),
              "allow-clear": "",
              class: "formItem",
              placeholder: "请输入标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          "content-flex": false,
          "merge-props": false,
          label: "题目限制"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, {
              class: "formItem",
              direction: "vertical",
              fill: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  field: "judgeConfig.memoryLimit",
                  label: "内存限制"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      modelValue: question.value.judgeConfig.memoryLimit,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((question.value.judgeConfig.memoryLimit) = $event)),
                      class: "input-demo",
                      min: "0",
                      placeholder: "请输入内存限制",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  field: "judgeConfig.stackLimit",
                  label: "堆栈限制"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      modelValue: question.value.judgeConfig.stackLimit,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((question.value.judgeConfig.stackLimit) = $event)),
                      class: "input-demo",
                      min: "0",
                      placeholder: "请输入堆栈限制",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  field: "judgeConfig.timeLimit",
                  label: "时间限制"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      modelValue: question.value.judgeConfig.timeLimit,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((question.value.judgeConfig.timeLimit) = $event)),
                      class: "input-demo",
                      min: "0",
                      placeholder: "请输入时间限制",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "测试用例配置" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, {
              class: "formItem",
              direction: "vertical",
              fill: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.judgeCase, (judgeCaseItem, index) => {
                  return (_openBlock(), _createBlock(_component_a_form_item, {
                    key: index + 1,
                    label: `测试用例 ${index + 1}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, {
                        class: "formInput",
                        direction: "vertical",
                        fill: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_a_form_item, {
                            key: index + 1,
                            field: `question.judgeCase[${index + 1}].input`,
                            label: `输入用例`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                modelValue: judgeCaseItem.input,
                                "onUpdate:modelValue": ($event: any) => ((judgeCaseItem.input) = $event),
                                placeholder: "请输入测试输入用例"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["field"])),
                          (_openBlock(), _createBlock(_component_a_form_item, {
                            key: index + 1,
                            field: `question.judgeCase[${index + 1}].output`,
                            label: `输出用例`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                modelValue: judgeCaseItem.output,
                                "onUpdate:modelValue": ($event: any) => ((judgeCaseItem.output) = $event),
                                placeholder: "请输入测试输出用例"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["field"])),
                          _createVNode(_component_a_button, {
                            style: { width: '20%' },
                            status: "danger",
                            onClick: ($event: any) => (handleDelete(index))
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("删除 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128)),
                _createVNode(_component_a_button, {
                  status: "success",
                  style: {"width":"20%"},
                  type: "outline",
                  onClick: handleAdd
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("新增测试用例 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          "html-type": "submit",
          style: {"width":"20%"},
          type: "primary"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("提交 ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})